import { CreateLogger, DateHelper, NameHelper } from "@swivl-mono/helpers";
import { Channel, EscalationInterface, EscalationStatus, Log, OnlineRosterEntry, SessionInterface, UserInterface } from "@swivl-mono/types";
import { stat } from "fs";
import { act } from "react";

import CallModel, { CallStatus } from "../../CallModel/Call.Model";
import { Member } from "../../Member/Member.Current";
import { UserConversationsInterface, UsersModel, UsersModelStoreInterface } from "../Users.Model";
import { UsersModelSetDataHelpers } from "./Users.Model.SetData.Helpers";

const log = CreateLogger(Log.USERS, "setData");

// function FixDates<T>(items: any[]): T[] {
//   const fieldsToFix = ["lastInteractionAt", "lastUserMessageAt", "createdAt", "updatedAt", "searchingForNextAgentAt", "lastMessageAt"];
//   return items.map((item) => {
//     for (const field of fieldsToFix) {
//       if (item[field]) {
//         if (typeof item[field] === "string") {
//           item[field] = new Date(item[field]);
//         } else if (!(item[field] instanceof Date)) {
//           item[field] = new Date(item[field]);
//         }
//       }
//     }
//     return item as T;
//   }) as T[];
// }

export function UsersModelSetDataMethod(
  users?: UserInterface[],
  sessions?: SessionInterface[],
  escalations?: EscalationInterface[],
  additionalData?: Partial<UsersModelStoreInterface>,
  usersOnline?: { [userId: number]: OnlineRosterEntry },
) {
  console.time("UsersModelSetDataMethod");
  let state = { ...UsersModel.state };
  const data = UsersModelSetDataHelpers.compileAllUsersSessionsAndEscalations(state, users, sessions, escalations);

  const conversations = UsersModelSetDataHelpers.createUserConversationsFromDataMap(data);

  state.users = UsersModelSetDataHelpers.mappedFromObjects(data.users);
  state.sessions = UsersModelSetDataHelpers.mappedFromObjects(data.sessions);
  state.escalations = UsersModelSetDataHelpers.mappedFromObjects(data.escalations);
  state.conversations = conversations;
  state.usersOnline = usersOnline ? usersOnline : undefined;

  if (additionalData) {
    for (const key in additionalData) {
      if (Object.prototype.hasOwnProperty.call(additionalData, key)) {
        state[key] = additionalData[key];
      }
    }
  }
  // sort users by last interaction date

  state.unacknowledgedEscalations = UsersModelSetDataHelpers.getUnacknowledgedEscalations(state.escalations);
  state = UsersModelSetDataHelpers.removeDeletedOrgMergedUsersFromConversations(state);
  state = UsersModelSetDataHelpers.setLastMessageForConversations(state);

  log("## new state :", { ...state });
  UsersModel.internalSetState(state);

  // check to see if we need to load any users for conversations that may not have it.

  let userIdsOfUsersToLoad: number[] = [];

  if (sessions && state.conversations) {
    // NOTE - we only ever want to load other users if we are setting sessions, otherwise there is a potential for an infinite loop.
    for (const [key, value] of Object.entries(state.conversations)) {
      if (!value.user) {
        userIdsOfUsersToLoad.push(Number(key));
      }
    }
    if (userIdsOfUsersToLoad.length) {
      UsersModel.loadUsersByIds(userIdsOfUsersToLoad);
    }
  }
  console.timeEnd("UsersModelSetDataMethod");
}
